import { apiGet } from "../client";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/query-keys";
import type { IPagination, IPaginationParams } from "@/types/pagination";
import type { IUser } from "@/apis/users/getMe";

// 그룹 정보 인터페이스 정의
export interface IGroup {
  id: string;
  name: string;
  status: string;
  users?: IUser[];
  user_count: number;
  created_at: string;
  updated_at: string;
}

// 그룹 목록 쿼리 파라미터 인터페이스
export interface IGroupListParams extends IPaginationParams {
  name?: string;
  status?: string;
}

/**
 * 그룹 목록을 조회하는 API 함수
 * @param params 쿼리 파라미터 (필터링, 페이징)
 * @returns API 응답 객체
 */
export const apiGetGroupList = async (params?: IGroupListParams) => {
  const response = await apiGet<IPagination<IGroup>>("/groups", params);
  return response;
};

/**
 * 그룹 목록을 React Query를 통해 조회하는 훅
 * @param params 쿼리 파라미터 (필터링, 페이징)
 * @param options React Query 옵션
 * @returns 쿼리 결과
 */
export const useQueryGetGroupList = (
  params?: IGroupListParams,
  options = {}
) => {
  // 파라미터가 변경되면 쿼리 키가 변경되도록 파라미터를 쿼리 키에 포함
  const queryKey = QueryKeys.group.list(params);

  return useQuery({
    queryKey,
    queryFn: async () => {
      const response = await apiGetGroupList(params);
      return response.data;
    },
    ...options,
  });
};

export default useQueryGetGroupList;
